export { default as LoyaltyHistoryWidget } from './loyalty-history-widget';
